<template>
  <paper-simple body-class="p-0 overflow-hidden">
    <div class="d-flex intro-bg px-1 py-2 w-full position-relative">
      <div
        :style="{
          backgroundImage: `url(${require('@/assets/images/banner/gj-banner-info.png')})`,
        }"
        class="intro-bg-image"
      />
      <div class="intro-bg-gradient" />
      <b-container>
        <b-row>
          <b-col>
            <h4 class="text-main m-0">
              {{ title }}
            </h4>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <slot />
  </paper-simple>
</template>

<script>
export default {
  name: 'StorageIntro',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.intro-bg-image {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  filter: opacity(20%);
}
.intro-bg-gradient {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(0, 0, 0, 0) 100%
  );
}
</style>
